import _ from "lodash";
import {
    UI_COLLAPSE_ELEMENT,
    UI_EXPAND_ELEMENT,
    RESET_HASH_PARAMS,
    STORE_HASH_PARAMS,
    UPDATE_HASH_PARAMS
} from "../actions/actionTypes/";
import Config from "../config/main";

const UIStateReducer = (state = {
    prematchTimeFilter: Config.main.defaultPrematchTimeFilter ? Config.main.defaultPrematchTimeFilter : 0,
    liveVideoFilter: 'all',
    hideDownloadAppPopup: false,
    hideCasinoDownloadAppPopup: false,
    prematchWidgetTimeFilter: Config.main.prematchWidgetTimeFilterValues[0],
    expanded: {},
    hashParams: {}
}, action = {}) => {
    let ret = _.cloneDeep(state);
    switch (action.type) {
        case UI_COLLAPSE_ELEMENT:
            ret.expanded[action.payload] = false;
            return ret;
        case UI_EXPAND_ELEMENT:
            ret.expanded[action.payload] = true;
            return ret;
        case STORE_HASH_PARAMS:
            return {
                ...ret,
                hashParams: action.payload
            };
        case RESET_HASH_PARAMS:
            return {
                ...ret,
                hashParams: {}
            };
        case UPDATE_HASH_PARAMS:
            return {
                ...ret,
                hashParams: {
                    ...ret.hashParams,
                    ...action.payload
                }
            };
        default :
            return state;
    }
};

export default UIStateReducer;